var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingCartFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2728_30043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.800049 5.14258H4.00005L6.14405 16.6197C6.2172 17.0143 6.41758 17.3688 6.71009 17.6211C7.0026 17.8734 7.36861 18.0074 7.74405 17.9997H15.52C15.8955 18.0074 16.2615 17.8734 16.554 17.6211C16.8465 17.3688 17.0469 17.0143 17.12 16.6197L18.4 9.42829H4.80005M8.00005 22.2854C8.00005 22.7588 7.64188 23.1426 7.20005 23.1426C6.75822 23.1426 6.40005 22.7588 6.40005 22.2854C6.40005 21.812 6.75822 21.4283 7.20005 21.4283C7.64188 21.4283 8.00005 21.812 8.00005 22.2854ZM16.8 22.2854C16.8 22.7588 16.4419 23.1426 16 23.1426C15.5582 23.1426 15.2 22.7588 15.2 22.2854C15.2 21.812 15.5582 21.4283 16 21.4283C16.4419 21.4283 16.8 21.812 16.8 22.2854Z",
    stroke: "#3E5156",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6415,
    cy: 6.06641,
    rx: 5.6,
    ry: 6,
    fill: "#F03D3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2728_30043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartFull);
export default __webpack_public_path__ + "static/media/shopping-cart-full.3e380bc40dcb99059f580ddb26023b49.svg";
export { ForwardRef as ReactComponent };